import { createStore } from 'vuex'

export default createStore({
  state: {
    orderinfo: {},
  },
  getters: {

  },
  mutations: {
    setorderinfo(state, val) {
      state.orderinfo = val;
    }
  },
  actions: {
  },
  modules: {
    
  }
})
